export const headers = [
  { text: "Descrição Analise",                value: "descricao_analise",   style: { width: '300px' } },
  { text: "Filial",                           value: "id_descricao_filial", style: { textAlign:'end' } },
  { text: "Dt Solicitação",                   value: "data_solicitacao", style: { textAlign:'end' } },
  { text: "Dt Previsão",                      value: "data_previsao", style: { textAlign:'end' } },
  { text: "Dt Entrada",                       value: "data_entrega", style: { textAlign:'end' } },
  { text: "Dt Faturamento",                   value: "data_faturamento", style: { textAlign:'end' } },
  { text: "UND",                              value: "unidade_compra", style: { textAlign:'end' } },
  { text: "Qntd Pendente",                    value: "qtde_pendente", style: { textAlign:'end' } },
  { text: "Qntd Faturada",                    value: "qtde_faturada", style: { textAlign:'end' } },
  { text: "Qntd Total",                       value: "qtde_compra", style: { textAlign:'end' } },
  { text: "Vlr Unit.",                        value: "preco_compra", style: { textAlign:'end' } },
  { text: "Total Pendente (R$ Compras)",      value: "total_pendente", style: { textAlign:'end' } },
  { text: "Total Faturado (R$ Compras)",      value: "total_faturado", style: { textAlign:'end' } },
  { text: "Total (R$ Compras)",               value: "total_compra", style: { textAlign:'end' } },
  { text: "Dias Em Aberto",                   value: "dias_em_aberto", style: { textAlign:'end' } }
];

export const colunas_ordenacao = [
  { descricao: "Descrição Analise",           campo: "descricao_analise", },
  { descricao: "Filial",                      campo: "id_descricao_filial" },
  { descricao: "Dt Solicitação",              campo: "data_solicitacao" },
  { descricao: "Dt Previsão",                 campo: "data_previsao" },
  { descricao: "Dt Entrada",                  campo: "data_entrega" },
  { descricao: "Dt Faturamento",              campo: "data_faturamento" },
  { descricao: "UND",                         campo: "unidade_compra" },
  { descricao: "Qntd Pendente",               campo: "qtde_pendente" },
  { descricao: "Qntd Faturada",               campo: "qtde_faturada" },
  { descricao: "Qntd Total",                  campo: "qtde" },
  { descricao: "Vlr Unit.",                   campo: "preco_compra" },
  { descricao: "Total Pendente (R$ Compras)", campo: "total_pendente" },
  { descricao: "Total Faturado (R$ Compras)", campo: "total_faturado" },
  { descricao: "Total (R$ Compras)",          campo: "total_compra" },
  { descricao: "Dias Em Aberto",              campo: "dias_em_aberto"  }
];
